
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('acclaim-ratings') && (binding.modules['acclaim-ratings'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-acclaim-ratings' */
            'partner/modules/acclaim-ratings/acclaim-ratings.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'acclaim-ratings',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/acclaim-ratings'
    });
        

    isNotRegistered('account-profile-edit') && (binding.modules['account-profile-edit'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-profile-edit' */
            'partner/modules/account-profile-edit/account-profile-edit.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'account-profile-edit',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/account-profile-edit'
    });
        

    isNotRegistered('add-to-cart-by-url') && (binding.modules['add-to-cart-by-url'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-add-to-cart-by-url' */
            'partner/modules/add-to-cart-by-url/add-to-cart-by-url.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'add-to-cart-by-url',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/add-to-cart-by-url'
    });
        

    isNotRegistered('age-gate') && (binding.modules['age-gate'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-age-gate' */
            'partner/modules/age-gate/age-gate.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'age-gate',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/age-gate'
    });
        

    isNotRegistered('all-purpose-tasting-tours') && (binding.modules['all-purpose-tasting-tours'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-all-purpose-tasting-tours' */
            'partner/modules/all-purpose-tasting-tours/all-purpose-tasting-tours.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'all-purpose-tasting-tours',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/all-purpose-tasting-tours'
    });
        

    isNotRegistered('blend') && (binding.modules['blend'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-blend' */
            'partner/themes/blend/blend.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['checkout-apple-pay','checkout','content-block','header','smwe-buybox','smwe-checkout','smwe-navigation-menu','wine-club-signup'],
        iNM: false,
        ns: '__local__',
        n: 'blend',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'blend.theme.settings.json',
        md: 'src/themes/blend'
    });
        

    isNotRegistered('cart-affiliations-maintainer') && (binding.modules['cart-affiliations-maintainer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-affiliations-maintainer' */
            'partner/modules/cart-affiliations-maintainer/cart-affiliations-maintainer.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'cart-affiliations-maintainer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cart-affiliations-maintainer'
    });
        

    isNotRegistered('cartmanager') && (binding.modules['cartmanager'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cartmanager' */
            'partner/modules/cartmanager/cartmanager.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'cartmanager',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cartmanager'
    });
        

    isNotRegistered('checkout-club-info-collector') && (binding.modules['checkout-club-info-collector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-club-info-collector' */
            'partner/modules/checkout-club-info-collector/checkout-club-info-collector.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'employeeReferralsList',  path:'actions/get-employee-referrals-list.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-club-info-collector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-club-info-collector'
    });
        

    isNotRegistered('checkout-date-of-birth') && (binding.modules['checkout-date-of-birth'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-date-of-birth' */
            'partner/modules/checkout-date-of-birth/checkout-date-of-birth.tsx'),
        $type: 'contentModule',
        da: [{name:'checkoutState',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-date-of-birth',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-date-of-birth'
    });
        

    isNotRegistered('clear-wineclub') && (binding.modules['clear-wineclub'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-clear-wineclub' */
            'partner/modules/clear-wineclub/clear-wineclub.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'clear-wineclub',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/clear-wineclub'
    });
        

    isNotRegistered('clickable-container') && (binding.modules['clickable-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-clickable-container' */
            'partner/modules/clickable-container/clickable-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'clickable-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/clickable-container'
    });
        

    isNotRegistered('colsolare') && (binding.modules['colsolare'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-colsolare' */
            'partner/themes/colsolare/colsolare.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'colsolare',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'colsolare.theme.settings.json',
        md: 'src/themes/colsolare'
    });
        

    isNotRegistered('columbiacrest') && (binding.modules['columbiacrest'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-columbiacrest' */
            'partner/themes/columbiacrest/columbiacrest.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'columbiacrest',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'columbiacrest.theme.settings.json',
        md: 'src/themes/columbiacrest'
    });
        

    isNotRegistered('conditional-container') && (binding.modules['conditional-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-conditional-container' */
            'partner/modules/conditional-container/conditional-container.tsx'),
        $type: 'containerModule',
        da: [{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'conditional-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/conditional-container'
    });
        

    isNotRegistered('conn-creek') && (binding.modules['conn-creek'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-conn-creek' */
            'partner/themes/conn-creek/conn-creek.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header'],
        iNM: false,
        ns: '__local__',
        n: 'conn-creek',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'conn-creek.theme.settings.json',
        md: 'src/themes/conn-creek'
    });
        

    isNotRegistered('container-with-header') && (binding.modules['container-with-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-container-with-header' */
            'partner/modules/container-with-header/container-with-header.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'container-with-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/container-with-header'
    });
        

    isNotRegistered('content-block-no-headings') && (binding.modules['content-block-no-headings'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-block-no-headings' */
            'partner/modules/content-block-no-headings/content-block-no-headings.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'content-block-no-headings',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/content-block-no-headings'
    });
        

    isNotRegistered('content-block-with-title') && (binding.modules['content-block-with-title'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-block-with-title' */
            'partner/modules/content-block-with-title/content-block-with-title.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'content-block-with-title',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/content-block-with-title'
    });
        

    isNotRegistered('content-with-media') && (binding.modules['content-with-media'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-with-media' */
            'partner/modules/content-with-media/content-with-media.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'content-with-media',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/content-with-media'
    });
        

    isNotRegistered('cookbook-tagline') && (binding.modules['cookbook-tagline'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cookbook-tagline' */
            'partner/modules/cookbook-tagline/cookbook-tagline.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'cookbook-tagline',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cookbook-tagline'
    });
        

    isNotRegistered('copyright') && (binding.modules['copyright'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-copyright' */
            'partner/modules/copyright/copyright.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'copyright',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/copyright'
    });
        

    isNotRegistered('element-scroller') && (binding.modules['element-scroller'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-element-scroller' */
            'partner/modules/element-scroller/element-scroller.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'element-scroller',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/element-scroller'
    });
        

    isNotRegistered('elicit') && (binding.modules['elicit'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-elicit' */
            'partner/themes/elicit/elicit.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['checkout','content-block','header','smwe-buybox','smwe-checkout','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'elicit',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'elicit.theme.settings.json',
        md: 'src/themes/elicit'
    });
        

    isNotRegistered('elicit-cart') && (binding.modules['elicit-cart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-elicit-cart' */
            'partner/modules/elicit-cart/elicit-cart.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'elicit-cart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/elicit-cart'
    });
        

    isNotRegistered('elicit-subscriptions') && (binding.modules['elicit-subscriptions'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-elicit-subscriptions' */
            'partner/modules/elicit-subscriptions/elicit-subscriptions.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'checkoutState',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 0},{name:'listPageState',  path:'dataActions/search-result-container/list-page-state', runOn: 0},{name:'products',  path:'dataActions/search-result-container/smwe-get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'dataActions/search-result-container/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'dataActions/search-result-container/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'elicit-subscriptions',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/elicit-subscriptions'
    });
        

    isNotRegistered('emp') && (binding.modules['emp'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-emp' */
            'partner/themes/emp/emp.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['carousel','checkout-apple-pay','content-block','header','smwe-search-result-container'],
        iNM: false,
        ns: '__local__',
        n: 'emp',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'emp.theme.settings.json',
        md: 'src/themes/emp'
    });
        

    isNotRegistered('employee-route-switcher') && (binding.modules['employee-route-switcher'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-employee-route-switcher' */
            'partner/modules/employee-route-switcher/employee-route-switcher.tsx'),
        $type: 'contentModule',
        da: [{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'employee-route-switcher',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/employee-route-switcher'
    });
        

    isNotRegistered('enoteca') && (binding.modules['enoteca'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-enoteca' */
            'partner/themes/enoteca/enoteca.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','header'],
        iNM: false,
        ns: '__local__',
        n: 'enoteca',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'enoteca.theme.settings.json',
        md: 'src/themes/enoteca'
    });
        

    isNotRegistered('erath') && (binding.modules['erath'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-erath' */
            'partner/themes/erath/erath.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header'],
        iNM: false,
        ns: '__local__',
        n: 'erath',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'erath.theme.settings.json',
        md: 'src/themes/erath'
    });
        

    isNotRegistered('event-description') && (binding.modules['event-description'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-event-description' */
            'partner/modules/event-description/event-description.tsx'),
        $type: 'contentModule',
        da: [{name:'eventDescription',  path:'dataActions/get-event-description', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'event-description',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/event-description'
    });
        

    isNotRegistered('event-list') && (binding.modules['event-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-event-list' */
            'partner/modules/event-list/event-list.tsx'),
        $type: 'contentModule',
        da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'products',  path:'dataActions/get-products-with-attributes-by-category', runOn: 0},{name:'refineSearchProducts',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-products-by-refine-search-category', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'event-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/event-list'
    });
        

    isNotRegistered('event-schedule') && (binding.modules['event-schedule'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-event-schedule' */
            'partner/modules/event-schedule/event-schedule.tsx'),
        $type: 'contentModule',
        da: [{name:'eventDescription',  path:'dataActions/get-event-description', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'event-schedule',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/event-schedule'
    });
        

    isNotRegistered('family-and-friends') && (binding.modules['family-and-friends'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-family-and-friends' */
            'partner/modules/family-and-friends/family-and-friends.tsx'),
        $type: 'contentModule',
        da: [{name:'codeList',  path:'modules/family-and-friends/actions/get-friends-and-family-list.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'family-and-friends',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/family-and-friends'
    });
        

    isNotRegistered('fth') && (binding.modules['fth'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-fth' */
            'partner/themes/fth/fth.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['carousel','checkout-apple-pay','container-with-header','content-block','header','order-confirmation','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'fth',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'fth.theme.settings.json',
        md: 'src/themes/fth'
    });
        

    isNotRegistered('generazioni') && (binding.modules['generazioni'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-generazioni' */
            'partner/themes/generazioni/generazioni.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header'],
        iNM: false,
        ns: '__local__',
        n: 'generazioni',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'generazioni.theme.settings.json',
        md: 'src/themes/generazioni'
    });
        

    isNotRegistered('gift-card-balance') && (binding.modules['gift-card-balance'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gift-card-balance' */
            'partner/modules/gift-card-balance/gift-card-balance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'gift-card-balance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gift-card-balance'
    });
        

    isNotRegistered('h3-theme') && (binding.modules['h3-theme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-h3-theme' */
            'partner/themes/h3-theme/h3-theme.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'h3-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'h3-theme.settings.json',
        md: 'src/themes/h3-theme'
    });
        

    isNotRegistered('home-carousel') && (binding.modules['home-carousel'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-home-carousel' */
            'partner/modules/home-carousel/home-carousel.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'home-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/home-carousel'
    });
        

    isNotRegistered('ie-only-message') && (binding.modules['ie-only-message'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ie-only-message' */
            'partner/modules/ie-only-message/ie-only-message.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ie-only-message',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ie-only-message'
    });
        

    isNotRegistered('iframe-module') && (binding.modules['iframe-module'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-iframe-module' */
            'partner/modules/iframe-module/iframe-module.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'iframe-module',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/iframe-module'
    });
        

    isNotRegistered('instagram-integration') && (binding.modules['instagram-integration'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-instagram-integration' */
            'partner/modules/instagram-integration/instagram-integration.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'instagram-integration',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/instagram-integration'
    });
        

    isNotRegistered('intrinsic-wine-co') && (binding.modules['intrinsic-wine-co'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-intrinsic-wine-co' */
            'partner/themes/intrinsic-wine-co/intrinsic-wine-co.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','header'],
        iNM: false,
        ns: '__local__',
        n: 'intrinsic-wine-co',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'intrinsic-wine-co.theme.settings.json',
        md: 'src/themes/intrinsic-wine-co'
    });
        

    isNotRegistered('lightbox') && (binding.modules['lightbox'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lightbox' */
            'partner/modules/lightbox/lightbox.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lightbox',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lightbox'
    });
        

    isNotRegistered('link-list') && (binding.modules['link-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-link-list' */
            'partner/modules/link-list/link-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'link-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/link-list'
    });
        

    isNotRegistered('logo-14hands') && (binding.modules['logo-14hands'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-logo-14hands' */
            'partner/modules/logo-14hands/logo-14hands.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'logo-14hands',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/logo-14hands'
    });
        

    isNotRegistered('lql') && (binding.modules['lql'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lql' */
            'partner/themes/lql/lql.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'lql',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'lql.settings.json',
        md: 'src/themes/lql'
    });
        

    isNotRegistered('mailing-list') && (binding.modules['mailing-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-mailing-list' */
            'partner/modules/mailing-list/mailing-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mailing-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mailing-list'
    });
        

    isNotRegistered('mailing-list-form') && (binding.modules['mailing-list-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-mailing-list-form' */
            'partner/modules/mailing-list-form/mailing-list-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mailing-list-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mailing-list-form'
    });
        

    isNotRegistered('mailing-list-popup-modal') && (binding.modules['mailing-list-popup-modal'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-mailing-list-popup-modal' */
            'partner/modules/mailing-list-popup-modal/mailing-list-popup-modal.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mailing-list-popup-modal',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mailing-list-popup-modal'
    });
        

    isNotRegistered('mailing-list-redirect-form') && (binding.modules['mailing-list-redirect-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-mailing-list-redirect-form' */
            'partner/modules/mailing-list-redirect-form/mailing-list-redirect-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mailing-list-redirect-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mailing-list-redirect-form'
    });
        

    isNotRegistered('multi-carousel') && (binding.modules['multi-carousel'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-multi-carousel' */
            'partner/modules/multi-carousel/multi-carousel.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'multi-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/multi-carousel'
    });
        

    isNotRegistered('north-star') && (binding.modules['north-star'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-north-star' */
            'partner/themes/north-star/north-star.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'north-star',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'north-star.theme.settings.json',
        md: 'src/themes/north-star'
    });
        

    isNotRegistered('notification') && (binding.modules['notification'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-notification' */
            'partner/modules/notification/notification.tsx'),
        $type: 'contentModule',
        da: [{name:'notification',  path:'dataActions/get-notification-message', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'notification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/notification'
    });
        

    isNotRegistered('offer-container') && (binding.modules['offer-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-offer-container' */
            'partner/modules/offer-container/offer-container.tsx'),
        $type: 'containerModule',
        da: [{name:'offerOptionBus',  path:'dataActions/wine-club-offers-bus', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'offer-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/offer-container'
    });
        

    isNotRegistered('offer-option-container') && (binding.modules['offer-option-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-offer-option-container' */
            'partner/modules/offer-option-container/offer-option-container.tsx'),
        $type: 'containerModule',
        da: [{name:'offerOptionBus',  path:'dataActions/wine-club-offers-bus', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'offer-option-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/offer-option-container'
    });
        

    isNotRegistered('overflow-container') && (binding.modules['overflow-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-overflow-container' */
            'partner/modules/overflow-container/overflow-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'overflow-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/overflow-container'
    });
        

    isNotRegistered('page-tos') && (binding.modules['page-tos'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-page-tos' */
            'partner/modules/page-tos/page-tos.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'page-tos',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/page-tos'
    });
        

    isNotRegistered('patzhall') && (binding.modules['patzhall'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-patzhall' */
            'partner/themes/patzhall/patzhall.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header'],
        iNM: false,
        ns: '__local__',
        n: 'patzhall',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'patzhall.theme.settings.json',
        md: 'src/themes/patzhall'
    });
        

    isNotRegistered('pdp-attributes') && (binding.modules['pdp-attributes'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-pdp-attributes' */
            'partner/modules/pdp-attributes/pdp-attributes.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'pdp-attributes',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/pdp-attributes'
    });
        

    isNotRegistered('pdp-dynamic-image') && (binding.modules['pdp-dynamic-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-pdp-dynamic-image' */
            'partner/modules/pdp-dynamic-image/pdp-dynamic-image.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'pdp-dynamic-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/pdp-dynamic-image'
    });
        

    isNotRegistered('product-apellation') && (binding.modules['product-apellation'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-apellation' */
            'partner/modules/product-apellation/product-apellation.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-apellation',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-apellation'
    });
        

    isNotRegistered('product-attributes') && (binding.modules['product-attributes'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-attributes' */
            'partner/modules/product-attributes/product-attributes.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-attributes',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-attributes'
    });
        

    isNotRegistered('product-container') && (binding.modules['product-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-container' */
            'partner/modules/product-container/product-container.tsx'),
        $type: 'containerModule',
        da: [{name:'productAttributes',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-container'
    });
        

    isNotRegistered('product-data-entry') && (binding.modules['product-data-entry'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-data-entry' */
            'partner/modules/product-data-entry/product-data-entry.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'product-data-entry',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-data-entry'
    });
        

    isNotRegistered('product-description') && (binding.modules['product-description'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-description' */
            'partner/modules/product-description/product-description.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-description',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-description'
    });
        

    isNotRegistered('product-link') && (binding.modules['product-link'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-link' */
            'partner/modules/product-link/product-link.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-link',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-link'
    });
        

    isNotRegistered('product-price') && (binding.modules['product-price'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-price' */
            'partner/modules/product-price/product-price.tsx'),
        $type: 'contentModule',
        da: [{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'hideClubPrice',  path:'dataActions/hide-club-price', runOn: 0},{name:'keyedInPrice',  path:'dataActions/get-keyed-in-price', runOn: 0},{name:'keyedInPriceError',  path:'dataActions/get-keyed-in-price-error', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productPrice',  path:'modules/product-price/data-actions/get-price-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-price',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-price'
    });
        

    isNotRegistered('product-skutitle') && (binding.modules['product-skutitle'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-skutitle' */
            'partner/modules/product-skutitle/product-skutitle.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 1},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'product-skutitle',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/product-skutitle'
    });
        

    isNotRegistered('promo-banner-cookie') && (binding.modules['promo-banner-cookie'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promo-banner-cookie' */
            'partner/modules/promo-banner-cookie/promo-banner-cookie.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'promo-banner-cookie',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/promo-banner-cookie'
    });
        

    isNotRegistered('reset-subscription') && (binding.modules['reset-subscription'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reset-subscription' */
            'partner/modules/reset-subscription/reset-subscription.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'reset-subscription',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/reset-subscription'
    });
        

    isNotRegistered('scroll-anim-container') && (binding.modules['scroll-anim-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-scroll-anim-container' */
            'partner/modules/scroll-anim-container/scroll-anim-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'scroll-anim-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/scroll-anim-container'
    });
        

    isNotRegistered('scroll-event-manager') && (binding.modules['scroll-event-manager'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-scroll-event-manager' */
            'partner/modules/scroll-event-manager/scroll-event-manager.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'scroll-event-manager',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/scroll-event-manager'
    });
        

    isNotRegistered('shipping-map') && (binding.modules['shipping-map'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-shipping-map' */
            'partner/modules/shipping-map/shipping-map.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'shipping-map',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/shipping-map'
    });
        

    isNotRegistered('shipping-popup') && (binding.modules['shipping-popup'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-shipping-popup' */
            'partner/modules/shipping-popup/shipping-popup.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'shipping-popup',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/shipping-popup'
    });
        

    isNotRegistered('shipping-service') && (binding.modules['shipping-service'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-shipping-service' */
            'partner/modules/shipping-service/shipping-service.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'shipping-service',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/shipping-service'
    });
        

    isNotRegistered('single-product-container') && (binding.modules['single-product-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-single-product-container' */
            'partner/modules/single-product-container/single-product-container.tsx'),
        $type: 'containerModule',
        da: [{name:'productAttributes',  path:'modules/single-product-container/data-actions/get-single-product', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'single-product-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/single-product-container'
    });
        

    isNotRegistered('smart-sticky-nav') && (binding.modules['smart-sticky-nav'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smart-sticky-nav' */
            'partner/modules/smart-sticky-nav/smart-sticky-nav.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'smart-sticky-nav',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smart-sticky-nav'
    });
        

    isNotRegistered('smwe') && (binding.modules['smwe'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe' */
            'partner/themes/smwe/smwe.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'smwe',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'smwe.theme.settings.json',
        md: 'src/themes/smwe'
    });
        

    isNotRegistered('smwe-account-management-address') && (binding.modules['smwe-account-management-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-account-management-address' */
            'partner/modules/smwe-account-management-address/smwe-account-management-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'countryRegions',  path:'dataActions/get-country-regions', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-account-management-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-account-management-address'
    });
        

    isNotRegistered('smwe-breadcrumb') && (binding.modules['smwe-breadcrumb'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-breadcrumb' */
            'partner/modules/smwe-breadcrumb/smwe-breadcrumb.tsx'),
        $type: 'contentModule',
        da: [{name:'breadcrumbData',  path:'modules/smwe-breadcrumb/actions/smwe-breadcrumb_data_action', runOn: 1},{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-breadcrumb',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-breadcrumb'
    });
        

    isNotRegistered('smwe-buybox') && (binding.modules['smwe-buybox'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-buybox' */
            'partner/modules/smwe-buybox/smwe-buybox.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 1},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant', runOn: 0},{name:'keyedInPrice',  path:'dataActions/get-keyed-in-price', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAvailability',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', runOn: 0},{name:'productPrice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-buybox',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-buybox'
    });
        

    isNotRegistered('smwe-cart') && (binding.modules['smwe-cart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-cart' */
            'partner/modules/smwe-cart/smwe-cart.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-cart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-cart'
    });
        

    isNotRegistered('smwe-checkout') && (binding.modules['smwe-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout' */
            'partner/modules/smwe-checkout/smwe-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/smwe-checkout/actions/get-products-in-active-smwe-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout'
    });
        

    isNotRegistered('smwe-checkout-billing-address') && (binding.modules['smwe-checkout-billing-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout-billing-address' */
            'partner/modules/smwe-checkout-billing-address/smwe-checkout-billing-address.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'dataActions/get-country-regions', runOn: 0},{name:'countryStates',  path:'dataActions/get-country-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout-billing-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout-billing-address'
    });
        

    isNotRegistered('smwe-checkout-delivery-options') && (binding.modules['smwe-checkout-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout-delivery-options' */
            'partner/modules/smwe-checkout-delivery-options/smwe-checkout-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout-delivery-options'
    });
        

    isNotRegistered('smwe-checkout-gift-card') && (binding.modules['smwe-checkout-gift-card'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout-gift-card' */
            'partner/modules/smwe-checkout-gift-card/smwe-checkout-gift-card.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout-gift-card',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout-gift-card'
    });
        

    isNotRegistered('smwe-checkout-section-container') && (binding.modules['smwe-checkout-section-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout-section-container' */
            'partner/modules/smwe-checkout-section-container/smwe-checkout-section-container.tsx'),
        $type: 'containerModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout-section-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout-section-container'
    });
        

    isNotRegistered('smwe-checkout-shipping-address') && (binding.modules['smwe-checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout-shipping-address' */
            'partner/modules/smwe-checkout-shipping-address/smwe-checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'cart',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-checkout-cart', runOn: 1},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'dataActions/get-country-regions', runOn: 0},{name:'countryStates',  path:'dataActions/get-country-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout-shipping-address'
    });
        

    isNotRegistered('smwe-checkout-terms-and-conditions') && (binding.modules['smwe-checkout-terms-and-conditions'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-checkout-terms-and-conditions' */
            'partner/modules/smwe-checkout-terms-and-conditions/smwe-checkout-terms-and-conditions.tsx'),
        $type: 'contentModule',
        da: [{name:'checkoutState',  path:'@msdyn365-commerce-modules/checkout-utilities/dist/lib/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-checkout-terms-and-conditions',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-checkout-terms-and-conditions'
    });
        

    isNotRegistered('smwe-content-block') && (binding.modules['smwe-content-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-content-block' */
            'partner/modules/smwe-content-block/smwe-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-content-block'
    });
        

    isNotRegistered('smwe-footer-category') && (binding.modules['smwe-footer-category'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-footer-category' */
            'partner/modules/smwe-footer-category/smwe-footer-category.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-footer-category',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-footer-category'
    });
        

    isNotRegistered('smwe-footer-item') && (binding.modules['smwe-footer-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-footer-item' */
            'partner/modules/smwe-footer-item/smwe-footer-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-footer-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-footer-item'
    });
        

    isNotRegistered('smwe-iframe') && (binding.modules['smwe-iframe'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-iframe' */
            'partner/modules/smwe-iframe/smwe-iframe.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-iframe',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-iframe'
    });
        

    isNotRegistered('smwe-media-gallery') && (binding.modules['smwe-media-gallery'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-media-gallery' */
            'partner/modules/smwe-media-gallery/smwe-media-gallery.tsx'),
        $type: 'containerModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-media-gallery',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-media-gallery'
    });
        

    isNotRegistered('smwe-minicart') && (binding.modules['smwe-minicart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-minicart' */
            'partner/modules/smwe-minicart/smwe-minicart.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-minicart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-minicart'
    });
        

    isNotRegistered('smwe-navigation-menu') && (binding.modules['smwe-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-navigation-menu' */
            'partner/modules/smwe-navigation-menu/smwe-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-navigation-menu'
    });
        

    isNotRegistered('smwe-order-details') && (binding.modules['smwe-order-details'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-order-details' */
            'partner/modules/smwe-order-details/smwe-order-details.tsx'),
        $type: 'contentModule',
        da: [{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-order-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-order-details'
    });
        

    isNotRegistered('smwe-order-history') && (binding.modules['smwe-order-history'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-order-history' */
            'partner/modules/smwe-order-history/smwe-order-history.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-order-history',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-order-history'
    });
        

    isNotRegistered('smwe-product-collection') && (binding.modules['smwe-product-collection'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-product-collection' */
            'partner/modules/smwe-product-collection/smwe-product-collection.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-product-collection',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-product-collection'
    });
        

    isNotRegistered('smwe-search') && (binding.modules['smwe-search'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-search' */
            'partner/modules/smwe-search/smwe-search.tsx'),
        $type: 'contentModule',
        da: [{name:'searchState',  path:'@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-search'
    });
        

    isNotRegistered('smwe-search-result-container') && (binding.modules['smwe-search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-search-result-container' */
            'partner/modules/smwe-search-result-container/smwe-search-result-container.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'listPageState',  path:'dataActions/search-result-container/list-page-state', runOn: 0},{name:'products',  path:'dataActions/search-result-container/smwe-get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'dataActions/search-result-container/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'dataActions/search-result-container/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-search-result-container'
    });
        

    isNotRegistered('smwe-sign-up') && (binding.modules['smwe-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-sign-up' */
            'partner/modules/smwe-sign-up/smwe-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-sign-up'
    });
        

    isNotRegistered('smwe-sku-selector-container') && (binding.modules['smwe-sku-selector-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-smwe-sku-selector-container' */
            'partner/modules/smwe-sku-selector-container/smwe-sku-selector-container.tsx'),
        $type: 'containerModule',
        da: [{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'smwe-sku-selector-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/smwe-sku-selector-container'
    });
        

    isNotRegistered('sort-and-filter-container') && (binding.modules['sort-and-filter-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sort-and-filter-container' */
            'partner/modules/sort-and-filter-container/sort-and-filter-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'sort-and-filter-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/sort-and-filter-container'
    });
        

    isNotRegistered('spring-valley-vineyard') && (binding.modules['spring-valley-vineyard'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-spring-valley-vineyard' */
            'partner/themes/spring-valley-vineyard/spring-valley-vineyard.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'spring-valley-vineyard',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'spring-valley-vineyard.theme.settings.json',
        md: 'src/themes/spring-valley-vineyard'
    });
        

    isNotRegistered('stagsleap') && (binding.modules['stagsleap'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-stagsleap' */
            'partner/themes/stagsleap/stagsleap.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['checkout-apple-pay','header','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'stagsleap',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'stagsleap.theme.settings.json',
        md: 'src/themes/stagsleap'
    });
        

    isNotRegistered('stemichelle') && (binding.modules['stemichelle'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-stemichelle' */
            'partner/themes/stemichelle/stemichelle.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout-apple-pay','content-block','header'],
        iNM: false,
        ns: '__local__',
        n: 'stemichelle',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'stemichelle.theme.settings.json',
        md: 'src/themes/stemichelle'
    });
        

    isNotRegistered('stemichelle-new') && (binding.modules['stemichelle-new'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-stemichelle-new' */
            'partner/themes/stemichelle-new/stemichelle-new.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['carousel','container-with-header','content-block','header','order-confirmation','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'stemichelle-new',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'stemichelle-new.theme.settings.json',
        md: 'src/themes/stemichelle-new'
    });
        

    isNotRegistered('subscription-box') && (binding.modules['subscription-box'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-subscription-box' */
            'partner/modules/subscription-box/subscription-box.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'subscription-box',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/subscription-box'
    });
        

    isNotRegistered('subscription-management') && (binding.modules['subscription-management'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-subscription-management' */
            'partner/modules/subscription-management/subscription-management.tsx'),
        $type: 'contentModule',
        da: [{name:'addresses',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'creditCards',  path:'modules/subscription-management/actions/get-subscription-cards.action', runOn: 1},{name:'subscriptions',  path:'modules/subscription-management/actions/get-subscriptions.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'subscription-management',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/subscription-management'
    });
        

    isNotRegistered('subscription-restriction-button') && (binding.modules['subscription-restriction-button'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-subscription-restriction-button' */
            'partner/modules/subscription-restriction-button/subscription-restriction-button.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'subscription-restriction-button',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/subscription-restriction-button'
    });
        

    isNotRegistered('subscriptions-minicart') && (binding.modules['subscriptions-minicart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-subscriptions-minicart' */
            'partner/modules/subscriptions-minicart/subscriptions-minicart.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'subscriptions-minicart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/subscriptions-minicart'
    });
        

    isNotRegistered('tasting-notes') && (binding.modules['tasting-notes'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-tasting-notes' */
            'partner/modules/tasting-notes/tasting-notes.tsx'),
        $type: 'contentModule',
        da: [{name:'productSpecificationData',  path:'dataActions/get-attributes-for-selected-variant', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'tasting-notes',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/tasting-notes'
    });
        

    isNotRegistered('timeline') && (binding.modules['timeline'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-timeline' */
            'partner/modules/timeline/timeline.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'timeline',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/timeline'
    });
        

    isNotRegistered('validation-form') && (binding.modules['validation-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-validation-form' */
            'partner/modules/validation-form/validation-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'validation-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/validation-form'
    });
        

    isNotRegistered('video-background') && (binding.modules['video-background'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-video-background' */
            'partner/modules/video-background/video-background.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'video-background',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/video-background'
    });
        

    isNotRegistered('vineyard-map') && (binding.modules['vineyard-map'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-vineyard-map' */
            'partner/modules/vineyard-map/vineyard-map.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'vineyard-map',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/vineyard-map'
    });
        

    isNotRegistered('wine-club') && (binding.modules['wine-club'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wine-club' */
            'partner/modules/wine-club/wine-club.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'wine-club',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wine-club'
    });
        

    isNotRegistered('wine-club-content') && (binding.modules['wine-club-content'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wine-club-content' */
            'partner/modules/wine-club-content/wine-club-content.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'wine-club-content',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wine-club-content'
    });
        

    isNotRegistered('wine-club-management') && (binding.modules['wine-club-management'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wine-club-management' */
            'partner/modules/wine-club-management/wine-club-management.tsx'),
        $type: 'contentModule',
        da: [{name:'countryRegions',  path:'dataActions/get-country-regions', runOn: 0},{name:'wineClubMember',  path:'modules/wine-club-management/actions/get-membership.action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'wine-club-management',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wine-club-management'
    });
        

    isNotRegistered('wine-club-signup') && (binding.modules['wine-club-signup'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wine-club-signup' */
            'partner/modules/wine-club-signup/wine-club-signup.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'wine-club-signup',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wine-club-signup'
    });
        

    isNotRegistered('wine-finder-by-zip') && (binding.modules['wine-finder-by-zip'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wine-finder-by-zip' */
            'partner/modules/wine-finder-by-zip/wine-finder-by-zip.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'wine-finder-by-zip',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wine-finder-by-zip'
    });
        

    isNotRegistered('wine-finder-form') && (binding.modules['wine-finder-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wine-finder-form' */
            'partner/modules/wine-finder-form/wine-finder-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'wine-finder-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/wine-finder-form'
    });
        

    isNotRegistered('wne') && (binding.modules['wne'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-wne' */
            'partner/themes/wine-estates/wne.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['carousel','checkout-apple-pay','container-with-header','content-block','header','order-confirmation','smwe-navigation-menu'],
        iNM: false,
        ns: '__local__',
        n: 'wne',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'wne.theme.settings.json',
        md: 'src/themes/wine-estates'
    });
        

    isNotRegistered('youtube-modal') && (binding.modules['youtube-modal'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-youtube-modal' */
            'partner/modules/youtube-modal/youtube-modal.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'youtube-modal',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/youtube-modal'
    });
        

        {   
            const actionPath = 'actions/get-availabilities-cartlines.overide.action';
            binding.dataActions[actionPath] = require('partner/actions/get-availabilities-cartlines.overide.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-employee-referrals-list.action';
            binding.dataActions[actionPath] = require('partner/actions/get-employee-referrals-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-availabilities-for-selected-variant.override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-availabilities-for-selected-variant.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-ratings-summary.override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-ratings-summary.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/products-by-category.action';
            binding.dataActions[actionPath] = require('partner/actions/products-by-category.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/products-by-recommendation.action';
            binding.dataActions[actionPath] = require('partner/actions/products-by-recommendation.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/family-and-friends/actions/get-friends-and-family-list.action';
            binding.dataActions[actionPath] = require('partner/modules/family-and-friends/actions/get-friends-and-family-list.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/family-and-friends/actions/validate-friends-and-family.action';
            binding.dataActions[actionPath] = require('partner/modules/family-and-friends/actions/validate-friends-and-family.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/subscription-management/actions/get-subscription-cards.action';
            binding.dataActions[actionPath] = require('partner/modules/subscription-management/actions/get-subscription-cards.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/subscription-management/actions/get-subscriptions.action';
            binding.dataActions[actionPath] = require('partner/modules/subscription-management/actions/get-subscriptions.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/subscription-management/actions/subscription-state.action';
            binding.dataActions[actionPath] = require('partner/modules/subscription-management/actions/subscription-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/subscription-management/actions/subscription-update.action';
            binding.dataActions[actionPath] = require('partner/modules/subscription-management/actions/subscription-update.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/wine-club-management/actions/get-membership.action';
            binding.dataActions[actionPath] = require('partner/modules/wine-club-management/actions/get-membership.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/wine-club-management/actions/membership-edit.action';
            binding.dataActions[actionPath] = require('partner/modules/wine-club-management/actions/membership-edit.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/wine-club-management/actions/membership-state.action';
            binding.dataActions[actionPath] = require('partner/modules/wine-club-management/actions/membership-state.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/wine-club-management/actions/wine-shipment-state.action';
            binding.dataActions[actionPath] = require('partner/modules/wine-club-management/actions/wine-shipment-state.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('cart-affiliations-maintainer')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cart-affiliations-maintainer')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cartmanager')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-club-info-collector')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-club-info-collector')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-club-info-collector')){
            const sanitizedActionPath = 'actions/get-employee-referrals-list.action';
            let dataAction = require('partner/actions/get-employee-referrals-list.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-date-of-birth')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('clear-wineclub')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('conditional-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cookbook-tagline')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('cookbook-tagline')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-cart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = 'dataActions/search-result-container/get-mapped-search-configuration';
            let dataAction = require('partner/dataActions/search-result-container/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = 'dataActions/search-result-container/get-refiners-for-collection';
            let dataAction = require('partner/dataActions/search-result-container/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = 'dataActions/search-result-container/list-page-state';
            let dataAction = require('partner/dataActions/search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('elicit-subscriptions')){
            const sanitizedActionPath = 'dataActions/search-result-container/smwe-get-full-products-by-collection';
            let dataAction = require('partner/dataActions/search-result-container/smwe-get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('employee-route-switcher')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-description')){
            const sanitizedActionPath = 'dataActions/get-event-description';
            let dataAction = require('partner/dataActions/get-event-description');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-products-by-refine-search-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-products-by-refine-search-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-list')){
            const sanitizedActionPath = 'dataActions/get-products-with-attributes-by-category';
            let dataAction = require('partner/dataActions/get-products-with-attributes-by-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-schedule')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-schedule')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('event-schedule')){
            const sanitizedActionPath = 'dataActions/get-event-description';
            let dataAction = require('partner/dataActions/get-event-description');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('family-and-friends')){
            const sanitizedActionPath = 'modules/family-and-friends/actions/get-friends-and-family-list.action';
            let dataAction = require('partner/modules/family-and-friends/actions/get-friends-and-family-list.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('notification')){
            const sanitizedActionPath = 'dataActions/get-notification-message';
            let dataAction = require('partner/dataActions/get-notification-message');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('offer-container')){
            const sanitizedActionPath = 'dataActions/wine-club-offers-bus';
            let dataAction = require('partner/dataActions/wine-club-offers-bus');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('offer-option-container')){
            const sanitizedActionPath = 'dataActions/wine-club-offers-bus';
            let dataAction = require('partner/dataActions/wine-club-offers-bus');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('pdp-attributes')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('pdp-attributes')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('pdp-dynamic-image')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-apellation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-apellation')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-attributes')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-attributes')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-container')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-description')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-description')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-link')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-price')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-price')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-price')){
            const sanitizedActionPath = 'dataActions/get-keyed-in-price';
            let dataAction = require('partner/dataActions/get-keyed-in-price');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-price')){
            const sanitizedActionPath = 'dataActions/get-keyed-in-price-error';
            let dataAction = require('partner/dataActions/get-keyed-in-price-error');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-price')){
            const sanitizedActionPath = 'dataActions/hide-club-price';
            let dataAction = require('partner/dataActions/hide-club-price');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-price')){
            const sanitizedActionPath = 'modules/product-price/data-actions/get-price-for-selected-variant';
            let dataAction = require('partner/modules/product-price/data-actions/get-price-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-skutitle')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('product-skutitle')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('reset-subscription')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('single-product-container')){
            const sanitizedActionPath = 'modules/single-product-container/data-actions/get-single-product';
            let dataAction = require('partner/modules/single-product-container/data-actions/get-single-product');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-account-management-address')){
            const sanitizedActionPath = 'dataActions/get-country-regions';
            let dataAction = require('partner/dataActions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-breadcrumb')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-breadcrumb')){
            const sanitizedActionPath = 'modules/smwe-breadcrumb/actions/smwe-breadcrumb_data_action';
            let dataAction = require('partner/modules/smwe-breadcrumb/actions/smwe-breadcrumb_data_action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-buybox')){
            const sanitizedActionPath = 'dataActions/get-keyed-in-price';
            let dataAction = require('partner/dataActions/get-keyed-in-price');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-cart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout')){
            const sanitizedActionPath = 'modules/smwe-checkout/actions/get-products-in-active-smwe-checkout-cart';
            let dataAction = require('partner/modules/smwe-checkout/actions/get-products-in-active-smwe-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-billing-address')){
            const sanitizedActionPath = 'dataActions/get-country-regions';
            let dataAction = require('partner/dataActions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-billing-address')){
            const sanitizedActionPath = 'dataActions/get-country-state';
            let dataAction = require('partner/dataActions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-gift-card')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-checkout-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-shipping-address')){
            const sanitizedActionPath = 'dataActions/get-country-regions';
            let dataAction = require('partner/dataActions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-shipping-address')){
            const sanitizedActionPath = 'dataActions/get-country-state';
            let dataAction = require('partner/dataActions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-checkout-terms-and-conditions')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout-utilities/dist/lib/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/checkout-utilities/dist/lib/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-media-gallery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-media-gallery')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-with-hydrations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-details')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-product-collection')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = 'dataActions/search-result-container/get-mapped-search-configuration';
            let dataAction = require('partner/dataActions/search-result-container/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = 'dataActions/search-result-container/get-refiners-for-collection';
            let dataAction = require('partner/dataActions/search-result-container/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = 'dataActions/search-result-container/list-page-state';
            let dataAction = require('partner/dataActions/search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-search-result-container')){
            const sanitizedActionPath = 'dataActions/search-result-container/smwe-get-full-products-by-collection';
            let dataAction = require('partner/dataActions/search-result-container/smwe-get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('smwe-sku-selector-container')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscription-box')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscription-management')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscription-management')){
            const sanitizedActionPath = 'modules/subscription-management/actions/get-subscription-cards.action';
            let dataAction = require('partner/modules/subscription-management/actions/get-subscription-cards.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscription-management')){
            const sanitizedActionPath = 'modules/subscription-management/actions/get-subscriptions.action';
            let dataAction = require('partner/modules/subscription-management/actions/get-subscriptions.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscription-restriction-button')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscriptions-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscriptions-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscriptions-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscriptions-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscriptions-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('subscriptions-minicart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('tasting-notes')){
            const sanitizedActionPath = 'dataActions/get-attributes-for-selected-variant';
            let dataAction = require('partner/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wine-club')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wine-club-management')){
            const sanitizedActionPath = 'dataActions/get-country-regions';
            let dataAction = require('partner/dataActions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wine-club-management')){
            const sanitizedActionPath = 'modules/wine-club-management/actions/get-membership.action';
            let dataAction = require('partner/modules/wine-club-management/actions/get-membership.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('wine-club-signup')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};